import React, { CSSProperties } from "react";
import { Input } from "./Input";
import { DateTime } from "luxon";
import cn from "classnames";
import { twMerge } from "tailwind-merge";

type Props = {
  disabled?: boolean;
  value: string | null | undefined;
  onChange: (value: string | null) => void;
  className?: string;
  style?: CSSProperties;
  withTime?: boolean;
};

export const parseDate = (value: string | null | undefined, withTime: boolean) => {
  if (value == null || value == "") {
    return undefined;
  }

  return DateTime.fromISO(value, {
    setZone: true,
    zone: "Europe/Moscow"
  }).toFormat(withTime ? "yyyy-MM-dd'T'HH:mm" : "yyyy-MM-dd");
};

export const InputDateTimeMoscow: React.FC<Props> = ({
                                                       value,
                                                       disabled = false,
                                                       withTime = true,
                                                       className,
                                                       style = {},
                                                       onChange
                                                     }) => {
  return (
    <>
      <Input
        disabled={disabled}
        containerClassName={cn("w-[200px]")}
        className={twMerge(cn("px-1 py-1", className))}
        style={{ ...style }}
        value={parseDate(value, withTime)}
        type={withTime ? "datetime-local" : "date"}
        onChange={(value: string | null) => {
          if (value == "") {
            value = null;
          }

          if (value != null && withTime) {
            value = value + ":00+03:00";
          }

          onChange(value);
        }}
      />
    </>
  );
};
